/**
 * 範例：專案申請表單的欄位關係配置
 * 
 * 這是一個完整的範例，展示如何定義表單欄位間的關係
 * 您可以複製這個檔案並修改為您自己的表單配置
 */

import { FormRelationshipConfig } from '../relationship-types';

export const ExampleProjectFormConfig: FormRelationshipConfig = {
  formId: 'example-project-form',
  formName: '範例專案申請表',
  description: '展示各種欄位關係的範例表單',
  version: '1.0.0',
  relationships: [
    {
      id: 'emergency_project_date_constraint',
      description: '緊急專案：限制開始日期和結束日期',
      when: {
        field: 'projectType',        // 監聽「專案類型」欄位
        equals: 'emergency'          // 當選擇「緊急」時
      },
      then: [
        {
          field: 'startDate',
          action: 'setMinDate',
          value: 'today'             // 開始日期最早為今天
        },
        {
          field: 'endDate',
          action: 'setMaxDate', 
          value: 'today+30'          // 結束日期最晚為30天後
        },
        {
          field: 'priority',
          action: 'setValue',
          value: 'high'              // 自動設定為高優先級
        }
      ]
    },

    {
      id: 'long_term_project_advance_notice',
      description: '長期專案：需要提前申請',
      when: {
        field: 'projectType',
        equals: 'long_term'
      },
      then: [
        {
          field: 'startDate',
          action: 'setMinDate',
          value: 'today+7'           // 最少提前7天申請
        },
        {
          field: 'budgetApproval',
          action: 'setVisible',
          value: true                // 顯示預算審核欄位
        },
        {
          field: 'budgetApproval',
          action: 'setRequired',
          value: true                // 設為必填
        }
      ]
    },

    {
      id: 'high_budget_manager_approval',
      description: '高預算專案：需要主管簽核',
      when: {
        field: 'estimatedBudget',
        greaterThan: 100000         // 預算超過10萬
      },
      then: [
        {
          field: 'managerApproval',
          action: 'setVisible',
          value: true
        },
        {
          field: 'managerApproval',
          action: 'setRequired',
          value: true
        },
        {
          field: 'budgetJustification',
          action: 'setVisible',
          value: true                // 顯示預算說明欄位
        }
      ]
    },

    {
      id: 'department_specific_requirements',
      description: '特定部門：額外需求',
      when: {
        field: 'department',
        in: ['研發部', '財務部', '人資部']
      },
      then: [
        {
          field: 'departmentHead',
          action: 'setRequired',
          value: true                // 部門主管必填
        },
        {
          field: 'riskAssessment',
          action: 'setVisible',
          value: true                // 顯示風險評估
        }
      ]
    },

    {
      id: 'external_project_additional_docs',
      description: '外部專案：需要額外文件',
      when: {
        field: 'isExternal',
        equals: true
      },
      then: [
        {
          field: 'contractDocument',
          action: 'setVisible',
          value: true
        },
        {
          field: 'contractDocument',
          action: 'setRequired',
          value: true
        },
        {
          field: 'externalPartner',
          action: 'setRequired',
          value: true
        }
      ]
    },

    {
      id: 'clear_end_date_when_no_start_date',
      description: '沒有開始日期時清除結束日期',
      when: {
        field: 'startDate',
        isEmpty: true
      },
      then: [
        {
          field: 'endDate',
          action: 'clearValue',
          value: null
        }
      ]
    },

    {
      id: 'custom_validation_example',
      description: '自定義條件：工時超過標準需要說明',
      when: {
        field: 'estimatedHours',
        custom: (value) => {
          const hours = parseFloat(value);
          return !isNaN(hours) && hours > 40; // 超過40小時
        }
      },
      then: [
        {
          field: 'overtimeReason',
          action: 'setVisible',
          value: true
        },
        {
          field: 'overtimeReason',
          action: 'setRequired',
          value: true
        }
      ]
    }
  ]
};

// 記得要在 index.ts 中註冊這個配置：
// 'example-project-form': ExampleProjectFormConfig,